export default "{\n    \"startDateLabel\": \"Fecha de inicio\",\n    \"endDateLabel\": \"Fecha de finalización\"\n}"